module.exports = __webpack_public_path__ + "media/images/flags/16/Cayman-Islands-0d2a081f7ae7895f94533628bb179434.png";